import { Progress, Tag, Tooltip } from "antd";
import { compare_icon } from "Benchmarking/Config/CompareIcon";
import { seniority_select } from "Benchmarking/Config/SelectData";
import { numberRegex } from "Benchmarking/Config/UtilFunction";

const ItemCompareFaculty = ({
  candidateList,
  setCandidateList,
  candidateIdList,
  setCandidateIdList,
  setCandidateIndex,
  candidates,
  setCandidates,
  setOpenAdd,
  maxData,
}) => {
  const showModal = (value) => {
    setOpenAdd(true);
    setCandidateIndex(value);
  };
  const handleRemoveCandidate = (index) => {
    setCandidateIndex(-1);
    const list = candidates.filter(
      (item) => item.id !== candidateList[`${index}`].data.id
    );
    const id_list = candidateIdList.filter(
      (item) => item !== candidateList[`${index}`].data.id
    );
    setCandidates(list);
    setCandidateIdList(id_list);
    if (index == 0) {
      setCandidateList({ ...candidateList, 0: null });
    } else if (index == 1) {
      setCandidateList({ ...candidateList, 1: null });
    } else if (index == 2) {
      setCandidateList({ ...candidateList, 2: null });
    } else if (index == 3) {
      setCandidateList({ ...candidateList, 3: null });
    }
  };
  console.log(candidateList);
  const tagRender = (label) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 7;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
        }}
        onMouseDown={onPreventMouseDown}
      >
        {isLongTag ? `${label.slice(0, 7)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const filterlabels = (index) => {
    let numFilters = 0;
    const allFilters = Object.keys(candidateList[`${index}`].filters).map(
      (key, i) => {
        const keywords_filter = candidateList[`${index}`].filters[key];
        if (keywords_filter && key != "query" && key != "seniorities") {
          return (
            <>
              {keywords_filter.map((filter) => {
                return <Tag>{filter}</Tag>;
              })}
            </>
          );
        } else if (key == "query" && keywords_filter) {
          return <Tag>{keywords_filter}</Tag>;
        } else if (key == "seniorities" && keywords_filter) {
          return (
            <>
              {keywords_filter.map((filter) => {
                return <Tag>{seniority_select[filter - 1].label}</Tag>;
              })}
            </>
          );
        }
      }
    );
    return (
      <>
        {Object.keys(candidateList[`${index}`].filters).map((key, i) => {
          const keywords_filter = candidateList[`${index}`].filters[key];
          if (keywords_filter && key != "query" && key != "seniorities") {
            return (
              <>
                {keywords_filter.map((filter) => {
                  numFilters += 1;
                  if (numFilters <= 6) {
                    return tagRender(filter);
                  }
                })}
              </>
            );
          } else if (key == "query" && keywords_filter) {
            numFilters += 1;
            if (numFilters <= 6) {
              return tagRender(keywords_filter);
            }
          } else if (key == "seniorities" && keywords_filter) {
            return (
              <>
                {keywords_filter.map((filter) => {
                  numFilters += 1;
                  if (numFilters <= 6) {
                    return tagRender(seniority_select[filter - 1].label);
                  }
                })}
              </>
            );
          }
        })}
        <Tooltip title={<div>{allFilters}</div>}>
          {numFilters > 6 && tagRender(`+${numFilters - 6}`)}
        </Tooltip>
      </>
    );
  };
  const itemCompareFaculty = (index) => {
    if (candidateList[`${index}`] !== null) {
      return (
        <div className="compare-item-filled">
          <div className="filters-keyword">
            <p>Filters:</p>
            {filterlabels(index)}
          </div>
          <img
            src={
              candidateList[`${index}`].data.photo_url
                ? candidateList[`${index}`].data.photo_url
                : "https://scholar.google.com/citations/images/avatar_scholar_256.png"
            }
            alt=""
          />
          <p className="name">{candidateList[`${index}`].data.name}</p>
          <p className="institution">
            {candidateList[`${index}`].data.institution.name}
          </p>
          <p className="position">{candidateList[`${index}`].data.position}</p>
          <div className="keywords">
            {candidateList[`${index}`].data.keywords
              .slice(0, 3)
              .map((tag, index) => {
                const isLongTag = tag.value.length > 11;
                const tagElem = (
                  <Tag key={tag.id}>
                    <span>
                      {isLongTag ? `${tag.value.slice(0, 11)}...` : tag.value}
                    </span>
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag.value} key={tag.id}>
                    {tagElem}
                  </Tooltip>
                ) : (
                  tagElem
                );
              })}
          </div>
          <div className="basic-stat-faculty">
            <div
              className={
                candidateList[`${index}`].data?.seniority == maxData.seniority
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Seniority:{" "}
                {numberRegex(candidateList[`${index}`].data?.seniority)}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data?.seniority /
                    maxData.seniority) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.scores.publication_count ==
                maxData.publication_count
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Publications:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.scores.publication_count
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.scores.publication_count /
                    maxData.publication_count) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.scores.citation_count.total ==
                maxData.citation_count
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                Citation count:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.scores.citation_count.total
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.scores.citation_count.total /
                    maxData.citation_count) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
            <div
              className={
                candidateList[`${index}`].data.scores["h-index"].total ==
                maxData["h-index"]
                  ? "statistic-item-max statistic-item"
                  : "statistic-item"
              }
            >
              <p>
                H-index:{" "}
                {numberRegex(
                  candidateList[`${index}`].data.scores["h-index"].total
                )}
              </p>
              <Progress
                percent={
                  (candidateList[`${index}`].data.scores["h-index"].total /
                    maxData["h-index"]) *
                  100
                }
                showInfo={false}
                steps={4}
              />
            </div>
          </div>
          <button
            onClick={() => {
              handleRemoveCandidate(index);
            }}
          >
            Remove candidate
          </button>
        </div>
      );
    } else {
      return (
        <div className="compare-item">
          <div className="icon">{compare_icon[`${index}`].icon}</div>
          <button
            onClick={() => {
              showModal();
              setCandidateIndex(index);
            }}
          >
            Add faculty member
          </button>
        </div>
      );
    }
  };
  return (
    <div className="compare-list">
      {Object.keys(candidateList).map((key, index) => {
        return itemCompareFaculty(key);
      })}
    </div>
  );
};

export default ItemCompareFaculty;
